import { Checkbox } from "components/DesignSystem/Checkbox/Checkbox";

type FilterOption = {
  value: string;
  label: string;
};

type FilterCheckboxListProps = {
  allLabel: string;
  options: FilterOption[];
  selected: string[] | null;
  onChange: (selected: string[] | null) => void;
};

export const FilterCheckboxList = ({
  allLabel,
  options,
  selected,
  onChange,
}: FilterCheckboxListProps) => {
  const values = options.map(({ value }) => value);
  const checkedValues = selected || values;
  const isAllSelected =
    selected === null || checkedValues.length === values.length;

  const handleAllChange = () => onChange(isAllSelected ? [] : null);

  const handleOptionChange = (value: string) => {
    const withoutValue = checkedValues.filter((current) => current !== value);
    const nextValues = checkedValues.includes(value)
      ? withoutValue
      : [...withoutValue, value];

    onChange(nextValues.length === values.length ? null : nextValues);
  };

  return (
    <div className="t-flex t-flex-col t-gap-4">
      <Checkbox
        checked={isAllSelected}
        label={allLabel}
        name="all"
        onChange={handleAllChange}
      />

      {options.map(({ value, label }) => (
        <Checkbox
          checked={checkedValues.includes(value)}
          key={value}
          label={label}
          name={value}
          onChange={() => handleOptionChange(value)}
        />
      ))}
    </div>
  );
};
